/*
  HLL visual pass: arrows on the product rows on phones.

  On phones the product rows (AW '26 on the home page, You may also like,
  Recently viewed, and the same rows on the cart page) are swipe rows.
  Section 21 of assets/hll-visual-pass.css sizes them to show one and a half
  products at a time. This script adds to each row:
    1. two round arrows that sit on the product photos, left and right. An
       arrow moves the row by one product and disappears when there is
       nothing more on that side. The first product sits against the left
       edge. From the second one on, each product stops in the middle of
       the screen
    2. where the section has a "View all" link in its heading, a copy of
       that link under the row. On phones the CSS hides the one in the
       heading and the "View all" tile at the end of the row.

  It covers every row built on the theme's .grid-overflow-wrapper, on any
  page, including rows the theme loads after the page (recommendations,
  recently viewed). All of it only shows on phones (the CSS hides it above
  768px), and the arrows only when the row has more than fits.

  If this script does not run, the rows still swipe. They have no arrows,
  and "View all" stays in the heading.
*/
(function () {
  'use strict';

  function update(wrap, nav) {
    // Put the arrows at the middle of the product photo
    var photo = wrap.querySelector('.grid-product__image-mask');
    if (photo) {
      var box = photo.getBoundingClientRect();
      var host = wrap.parentNode.getBoundingClientRect();
      if (box.height) nav.style.setProperty('--hll-row-arrow-y', Math.round(box.top - host.top + box.height / 2) + 'px');
    }
    // The theme slides the row in from the right. Switch the stops on only
    // once it is in place, so the row cannot settle on the wrong product.
    if (!wrap.classList.contains('hll-row-snap')) {
      var grid = wrap.querySelector('.grid');
      var shift = grid ? window.getComputedStyle(grid).transform : 'none';
      if (!shift || shift === 'none' || /^matrix\(1, 0, 0, 1, 0, 0\)$/.test(shift)) {
        wrap.classList.add('hll-row-snap');
      }
    }
    var max = wrap.scrollWidth - wrap.clientWidth;
    var x = wrap.scrollLeft;
    nav.hidden = max <= 4;
    nav.querySelector('.hll-row-nav__btn--prev').disabled = x <= 2;
    nav.querySelector('.hll-row-nav__btn--next').disabled = x >= max - 2;
  }

  // Products that are showing (the "View all" tile is hidden on phones)
  function products(wrap) {
    return Array.prototype.filter.call(wrap.querySelectorAll('.grid__item'), function (item) {
      return item.offsetWidth > 0;
    });
  }

  // Move one product. The first product sits against the left edge. Every
  // other product stops in the middle of the screen (the last one stops at
  // the right edge, because the row ends there).
  function step(wrap, direction) {
    var items = products(wrap);
    if (!items.length) return;
    var max = wrap.scrollWidth - wrap.clientWidth;
    var x = wrap.scrollLeft;
    var edge = wrap.getBoundingClientRect().left;
    var stops = items.map(function (item, index) {
      if (index === 0) return 0;
      var box = item.getBoundingClientRect();
      var middle = box.left - edge + x + box.width / 2;
      return Math.max(0, Math.min(max, middle - wrap.clientWidth / 2));
    });
    var current = 0;
    if (x >= max - 2) current = items.length - 1;
    else if (x > 2) {
      var best = Infinity;
      stops.forEach(function (stop, index) {
        var gap = Math.abs(stop - x);
        if (gap < best) {
          best = gap;
          current = index;
        }
      });
    }
    var next = Math.max(0, Math.min(items.length - 1, current + direction));
    var calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    wrap.scrollTo({ left: stops[next], behavior: calm ? 'auto' : 'smooth' });
  }

  function setup(wrap) {
    if (wrap.hllRowNav) return;
    if (wrap.querySelectorAll('.grid__item').length < 2) return;

    var nav = document.createElement('div');
    nav.className = 'hll-row-nav';
    [
      ['prev', -1, 'Previous products'],
      ['next', 1, 'More products']
    ].forEach(function (def) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'hll-row-nav__btn hll-row-nav__btn--' + def[0];
      button.setAttribute('aria-label', def[2]);
      button.addEventListener('click', function () {
        step(wrap, def[1]);
      });
      nav.appendChild(button);
    });
    wrap.parentNode.classList.add('hll-row');
    wrap.parentNode.insertBefore(nav, wrap.nextSibling);
    wrap.hllRowNav = nav;

    // "View all" under the row, copied from the link in the section heading
    var section = wrap.closest('.shopify-section');
    var link = section ? section.querySelector('.section-header__link[href]') : null;
    if (link && !section.querySelector('.hll-row-viewall')) {
      var holder = document.createElement('div');
      holder.className = 'hll-row-viewall';
      var copy = document.createElement('a');
      copy.href = link.getAttribute('href');
      copy.textContent = link.textContent.replace(/\s+/g, ' ').trim();
      holder.appendChild(copy);
      wrap.parentNode.insertBefore(holder, nav.nextSibling);
      section.classList.add('hll-row-has-viewall');
    }

    var queued = false;
    wrap.addEventListener(
      'scroll',
      function () {
        if (queued) return;
        queued = true;
        window.setTimeout(function () {
          queued = false;
          update(wrap, nav);
        }, 80);
      },
      { passive: true }
    );
    update(wrap, nav);

    // The row changes width when its photos load or it slides into place
    if ('ResizeObserver' in window) {
      var watcher = new ResizeObserver(function () {
        update(wrap, nav);
      });
      watcher.observe(wrap);
      var grid = wrap.querySelector('.grid');
      if (grid) watcher.observe(grid);
    }
  }

  function scan() {
    Array.prototype.forEach.call(document.querySelectorAll('.grid-overflow-wrapper'), function (wrap) {
      if (wrap.hllRowNav) update(wrap, wrap.hllRowNav);
      else setup(wrap);
    });
  }

  function boot() {
    scan();

    // Rows the theme fills in later, and images that change the row width
    var timer;
    function later() {
      window.clearTimeout(timer);
      timer = window.setTimeout(scan, 300);
    }
    var main = document.getElementById('MainContent') || document.body;
    if ('MutationObserver' in window) {
      new MutationObserver(later).observe(main, { childList: true, subtree: true });
    }
    window.addEventListener('resize', later);
    window.addEventListener('load', later);
    // The theme slides these rows in when they come on screen, which can
    // leave the arrows out of date. Check again once that has settled.
    main.addEventListener('transitionend', function (event) {
      if (event.target && event.target.getAttribute && event.target.getAttribute('data-aos')) later();
    });
    window.setTimeout(scan, 1500);
    window.setTimeout(scan, 4000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
